// Cancelling a supplier upload (2026-10-29). The backend decides whether a cancel is allowed
// (app/utils/delivery_cancel.py: 409 with a plain-language reason); this file only decides when to
// SHOW the control and how to word the results. A supplier uploaded a bad file and could not take it
// back, and a PM accepted it from Lead QA Review's new-deliveries notice.

export const CANCELLED_STATUS = 'Cancelled';

// Partners cancel their own supplier's uploads, admins any; the server enforces which.
const CANCEL_ROLES = ['partner', 'admin'];

// Show the Cancel control only on a delivery still waiting for a PM. Everything else the server
// would refuse anyway (accepted, already cancelled).
export function canCancelUpload(delivery, role) {
  return !!delivery && delivery.status === 'Pending' && CANCEL_ROLES.includes(role);
}

export function isCancelled(delivery) {
  return !!delivery && delivery.status === CANCELLED_STATUS;
}

// "Cancelled by Ruokuo · Wrong file" for a cancelled card; null when nothing was recorded.
export function cancelledSummary(delivery) {
  if (!isCancelled(delivery)) return null;
  const c = (delivery.row_counts && delivery.row_counts.cancelled) || {};
  const parts = [];
  if (c.by_name) parts.push(`Cancelled by ${c.by_name}`);
  else parts.push('Cancelled');
  if (c.reason) parts.push(c.reason);
  return parts.join(' · ');
}

// The 409 detail is already plain language ("A PM has already accepted this delivery..."), so show it as is.
export function describeCancelError(err) {
  const detail = err && err.response && err.response.data && err.response.data.detail;
  if (typeof detail === 'string' && detail) return detail;
  return 'Could not cancel this upload. Please try again.';
}

export function describeCancelResult(data) {
  const n = (data && data.leads_removed) || 0;
  return n
    ? `Upload cancelled. ${n} lead${n !== 1 ? 's' : ''} removed. The PM was told it was withdrawn.`
    : 'Upload cancelled. The PM was told it was withdrawn.';
}

// A PM's Accept / Mark Delivered is refused (409) for a held or cancelled delivery. The caller shows this
// text and refreshes its list so the delivery drops out of the queue.
export function isBlockedByHoldOrCancel(err) {
  return !!(err && err.response && err.response.status === 409);
}
